.section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.heading {
  margin: 0;
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 22px;
  text-transform: uppercase;
}

.sponsorGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 10px;
}

/* Same tile size/treatment as Desktop.dc.html/Main.dc.html's own "Site sponsors" placeholder
   grid (a different, not-yet-built sitewide ad slot) - reused here since it already reads right
   for a logo on this page's background, even though this card is the event's own sponsor list
   (eventsponsors), not that one. */
.sponsorLogoBox {
  height: 64px;
  border-radius: var(--r-10);
  background: var(--bg-panel);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
}

.sponsorLogo {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.extraCard {
  background: var(--bg-panel);
  border-radius: var(--r-12);
  border: 1px solid transparent;
  padding: 14px 16px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

/* Border-only highlight once added, matching ClassList's .rowEntered - the 1px-smaller padding
   offsets the border going from 1px to 2px so the card doesn't reflow when it becomes highlighted. */
.extraCardEntered {
  border: 2px solid var(--accent);
  padding: 13px 15px;
}

.extraName {
  font-weight: 700;
  font-size: 15px;
}

.extraDesc {
  font-size: 13px;
  color: var(--text-muted);
}

.extraPrice {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 18px;
  white-space: nowrap;
}

.extraControls {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.extraControls select {
  height: 40px;
  border-radius: var(--r-8);
  border: 1px solid var(--border-4);
  background: var(--bg-page);
  padding: 0 8px;
  font-size: 14px;
}

.extraAdd {
  height: 40px;
  padding: 0 14px;
  border-radius: var(--r-8);
  border: none;
  background: var(--accent-strong);
  color: var(--text-on-dark);
  font-weight: 600;
  font-size: 14px;
  white-space: nowrap;
}
.extraAdd:disabled {
  opacity: 0.5;
}

.extraError {
  font-size: 12px;
  color: var(--danger);
}

.extraStatus {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 15px;
}

.removeBtn {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  border-radius: 50%;
  border: none;
  background: var(--border-2);
  color: var(--text-muted);
  font-size: 15px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.removeBtn:hover {
  background: var(--danger);
  color: #fff;
}

.confirmText {
  font-size: 13px;
  color: var(--text-secondary);
}

.confirmYes,
.confirmNo {
  height: 28px;
  padding: 0 10px;
  border-radius: var(--r-pill);
  font-size: 12px;
  font-weight: 700;
  border: none;
}
.confirmYes {
  background: var(--danger);
  color: #fff;
}
.confirmNo {
  background: var(--border-2);
  color: var(--text-primary);
}

.extraPaidBadge {
  padding: 2px 10px;
  border-radius: var(--r-pill);
  background: var(--success);
  color: var(--text-on-dark);
  font-size: 12px;
  font-weight: 700;
}

.extraSoldOut {
  flex-shrink: 0;
  padding: 4px 10px;
  border-radius: var(--r-pill);
  background: var(--border-2);
  color: var(--text-muted);
  font-size: 12px;
  font-weight: 700;
}

.relatedGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 10px;
}

.relatedCard {
  background: var(--bg-panel);
  border-radius: var(--r-10);
  text-decoration: none;
  color: inherit;
  display: block;
  overflow: hidden;
}

.relatedImg {
  display: block;
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  background: var(--border-2);
}

.relatedBody {
  padding: 12px 14px;
}

.relatedName {
  font-weight: 600;
  font-size: 15px;
  color: var(--text-primary);
}

/* RaceTime Entertainment - a sitewide paid-partner promo card (Desktop.dc.html/Main.dc.html's
   dark aside card), not data about the event this page is showing. Plain border-radius/background,
   no tinted border like the (not-yet-built) Featured events card above it in the mockup. */
.raceTimeCard {
  background: var(--bg-dark);
  color: var(--text-on-dark);
  border-radius: var(--r-14);
  padding: 16px 16px 6px;
  display: flex;
  flex-direction: column;
}

.raceTimeTitle {
  margin: 0;
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 22px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding-bottom: 4px;
}

.raceTimeItem {
  display: flex;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid var(--bg-dark-panel);
  text-decoration: none;
  color: var(--text-on-dark);
}
.raceTimeItem:last-child {
  border-bottom: none;
}

.raceTimeThumb {
  width: 54px;
  height: 72px;
  flex-shrink: 0;
  border-radius: 6px;
  object-fit: cover;
}

.raceTimeThumbPlaceholder {
  width: 54px;
  height: 72px;
  flex-shrink: 0;
  border-radius: 6px;
  background: var(--bg-dark-panel);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  color: var(--text-on-dark-faint);
}

.raceTimeInfo {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.raceTimeDate {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: var(--accent-tint-text);
}

.raceTimeName {
  font-weight: 700;
  font-size: 15px;
  line-height: 1.25;
}

.raceTimeVenue {
  font-size: 13px;
  color: var(--text-on-dark-faint);
}

/* Featured events - sitewide paid-promotion card (Desktop.dc.html/Main.dc.html's white aside
   card with the orange-tinted border), not data about the event this page is showing. Rendered
   without a flyer column (an explicit ask) - its items stack their text instead of the
   flyer+text row the mockup itself uses, same simplification RaceTimeCard would need if its own
   thumbnail were ever dropped. */
.featuredCard {
  background: var(--bg-panel);
  border-radius: var(--r-14);
  border: 2px solid var(--border-accent-tint);
  padding: 16px 16px 6px;
  display: flex;
  flex-direction: column;
}

.featuredTitle {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 22px;
  text-transform: uppercase;
  color: var(--text-primary);
  padding-bottom: 4px;
}

.featuredTitle svg {
  display: flex;
  color: var(--accent-strong);
}

.featuredItem {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 12px 0;
  border-bottom: 1px solid var(--border-2);
  text-decoration: none;
  color: var(--text-primary);
}
.featuredItem:last-child {
  border-bottom: none;
}

.featuredDate {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: var(--accent-text);
}

.featuredName {
  font-weight: 700;
  font-size: 15px;
  line-height: 1.25;
}

.featuredVenue {
  font-size: 13px;
  color: var(--text-muted);
}
